const LoadingScreen = require('components/LoadingScreen');
const AuthConstants = require('services/auth-management/constants');
const { context } = require('app-context');

const ROUTES = AuthConstants.authFlow.routes;
const redux = context.redux.hooks;
const selectors = context.selectors.all;
const handlers = context.handlers;

module.exports = [
    {
        path: ROUTES.signup.authenticate,
        exact: true,
        component: LoadingScreen,
        onWillMount: async () => {

            if (handlers.auth.resolveAuthStatus) {
                await handlers.auth.resolveAuthStatus();
            }
            else {
                await handlers.auth.resolveIsAuthenticated();
            }

            const state = redux.getState();

            if (selectors.getIsAuthenticated(state)) {
                return { replace: ROUTES.app.welcome };
            }

            let signupContext = selectors.getSignupContext(state);

            if (signupContext.isEmailVerified === false) {
                return { replace: ROUTES.signup.verifyEmail };
            }

            const authenticateContext = selectors.getSignupAuthenticateDetails(state);
            const verificationToken = signupContext.verificationToken || authenticateContext.verificationToken;

            if (verificationToken) {
                const passwordCheck = await redux.dispatch(context.actions.signup.authenticate.checkPassword({
                    verificationToken
                }));

                signupContext = selectors.getSignupContext(redux.getState());

                if (!passwordCheck || signupContext.hasCompletedProfile !== true) {
                    return { replace: ROUTES.signup.profile };
                }

                const loginResult = await redux.dispatch(context.actions.auth.loginWithVerificationToken({ verificationToken }));

                if (loginResult) {
                    return;
                }

                signupContext = selectors.getSignupContext(redux.getState());

                if (signupContext.mfaToken) {
                    return;
                }

                return { replace: ROUTES.signup.profile };
            }

            const email = signupContext.email;
            const password = authenticateContext.password;

            if (email && password) {
                const loginResult = await redux.dispatch(context.actions.auth.login({ email, password }));

                return loginResult
                    ? undefined
                    : { replace: ROUTES.login.entry };
            }

            return { replace: ROUTES.login.entry };
        }
    }
];
